import React, { useRef, useState } from 'react';
import { Row, Col, Form } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton } from '@fluentui/react/lib/Button';
import { ConstrainMode, DetailsListLayoutMode, OverflowSet, SelectionMode, ShimmeredDetailsList, SpinnerSize, Toggle, TooltipHost } from '@fluentui/react';
import { useGetListDataserieValueDocuments } from '../../../../../../hooks/services/sKPI/useOfBoard';
import { __HoursValues, __KPIPeriods, __MessageTypes, __ShiftValues } from '../../../../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_GetDataserieValue } from '../../../../../../common/ObjectStructures/sKPI';
import { _global_buttonStyles } from '../../../../../../common/ObjectStructures/Trasnversal';
import { base64ToArrayBuffer, isNullUndefined, saveByteArray, showMessage } from '../../../../../../common/Helpers';
import PropTypes from 'prop-types';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../../common/CommonFuctions';
import { getDocumentsDownload } from '../../../../../../services/sKPI/gap.service';
import { updateDataserieValueDocumentDeactivate } from '../../../../../../services/sKPI/board.service';
import { addTransversalDocument } from '../../../../../../services/sBook/document.service';
import Loading from '../../../../../Templates/Site/Loading';
import { FILE_MAX_SIZE } from '../../../../../../configurations/application.config';
import { envBlobDocumentUpload, envDocumentGetUrl, envDocumentValidate } from '../../../../../../services/Env/transversal.service';

const DataserieValueDocumentBox = (props) => {

    const { 
        inputParam_IsPanelOpen = null,
        inputParam_ObjDataserieValueId = null,
        inputParam_SetMessageConfig = null,
        inputParam_EditMode = false,
        inputParam_DocumentLinkList = [],
        inputParam_SetDocumentLinkList = null,
    } = props;

    const { t } = useTranslation();
    const fileUploadControl = useRef();
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [downloadInProgress, setDownloadInProgress] = useState(false);

    const [showDeactivatedDocuments, setShowDeactivatedDocuments] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [documentLinkListOriginal, setDocumentLinkListOriginal] = useState(null);
    useGetListDataserieValueDocuments(inputParam_ObjDataserieValueId, inputParam_DocumentLinkList, inputParam_SetDocumentLinkList, setDocumentLinkListOriginal, inputParam_IsPanelOpen, showDeactivatedDocuments)

    const onUploadFile = async () => {
        //const ojbClientFormData = new FormData();
        //ojbClientFormData.append("file", selectedFile);
        //ojbClientFormData.append("id", inputParam_ObjDataserieValueId);
        //ojbClientFormData.append("url", 'skVariable/dataserievaluedocumentadd');

        if (!isNullUndefined(selectedFile)) {
            if (handleFileInput(selectedFile)) {
                showMessage(inputParam_SetMessageConfig, false, __MessageTypes.ERROR, '')
                setUploadInProgress(true);
                await envDocumentGetUrl('skVariable/dataserievaluedocumentadd', inputParam_ObjDataserieValueId, selectedFile.name).then(async (responseGetUrl) => {
                    setUploadInProgress(true);
                    if (responseGetUrl.data.succeeded === true) {
                        await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                            if (responseAzure.data === "" && responseAzure.status === 201) {
                                await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                    if (responseValidate.data.succeeded === true) {
                                        if (responseValidate.data.data.result_validate === true) {
                                            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                                            inputParam_SetDocumentLinkList(null);
                                            setSelectedFile(null);
                                            if (fileUploadControl.current) {
                                                fileUploadControl.current.value = '';
                                            }
                                            setUploadInProgress(false);
                                        }
                                        else {
                                            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.data.result_validate_msg))
                                            setDownloadInProgress(false)
                                        }
                                    }
                                    else {
                                        showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.message))
                                        setDownloadInProgress(false)
                                    }
                                })
                                .catch((error) => {
                                    console.log(error)
                                    showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setDownloadInProgress(false)
                                });;
                            }
                            else {
                                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setDownloadInProgress(false)
                            }
                        })
                        .catch(async (error) => {
                            await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                console.log(error)
                                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setDownloadInProgress(false)
                            })
                            .catch((error) => {
                                console.log(error)
                                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setDownloadInProgress(false)
                            });
                        });
                    } else {
                        showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t(responseGetUrl.data.message))
                        setDownloadInProgress(false)
                    }
                    setSelectedFile(null);
                    setUploadInProgress(false);
                })
                .catch((error) => {
                    console.log(error)
                    showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setDownloadInProgress(false);
                });
            }
            else {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
            }
        }
        else {
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
        }
    };
    
    const onDownloadDocumentsByIds = (documentList, fileName) => {
        setDownloadInProgress(true);
        getDocumentsDownload(documentList).then((response) => {
            saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
            setDownloadInProgress(false);
        }).catch((ex) => {
            console.log(ex)
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setDownloadInProgress(false)
        });
    }

    const onDeactivateDocumentsByIds = (documentId) => {
        updateDataserieValueDocumentDeactivate(documentId).then((response) => {
            if (response.data.succeeded) {
                inputParam_SetDocumentLinkList(inputParam_DocumentLinkList.filter(x => x.id !== documentId))
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const onDeleteDocumentsByIds = (documentId) => {
        updateDataserieValueDocumentDeactivate(documentId).then((response) => {
            if (response.data.succeeded) {
                inputParam_SetDocumentLinkList(inputParam_DocumentLinkList.filter(x => x.id !== documentId))
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const onCancelUpload = () => {
        setSelectedFile(null);
        fileUploadControl.current.value = "";
        showMessage(inputParam_SetMessageConfig, false, __MessageTypes.WARNING, '')
    }

    const handleFileInput = (e) => {
        // handle validations
        const file = !isNullUndefined(e.target) ? e.target.files[0] : e;
        let flag = false;
        
        if (file) {
            const maxSizeInMB = FILE_MAX_SIZE;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                setSelectedFile(file);
            }
            else {
                flag = true;
                setSelectedFile(file);
            }
        }

        return flag;
    };

    const onChangeShowDeactivatedDocuments = () => {
        if (!showDeactivatedDocuments) {
            inputParam_SetDocumentLinkList(documentLinkListOriginal)
        }
        else {
            inputParam_SetDocumentLinkList(documentLinkListOriginal.filter(x => x.deactivate === false))
        }

        setShowDeactivatedDocuments(!showDeactivatedDocuments)
    };


    return  <Row className="h-25 py-2 mt-3 border rounded-1">
                <Col xl={12}>
                    <h5 className='border-bottom'>
                    {t('data-lang-lbl-backupdocuments')}
                    </h5>
                </Col>
                <Col xl={12}>
                    <div className='d-flex float-end pb-3'>
                        {
                            inputParam_EditMode &&
                            <>
                                {
                                    //[##CODELCO-CARD-##] Mensaje error carga de documentos
                                    //Mensaje error carga de documentos
                                }
                                <TooltipHost content={
                                    <>
                                        <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
                                        <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
                                    </>
                                }>
                                <div className='d-flex align-items-center'>
                                    <Form.Control ref={fileUploadControl} type="file" size="sm" onChange={ handleFileInput } />
                                </div>
                                </TooltipHost>
                                {
                                    !uploadInProgress &&
                                    <ActionButton id="btnUpload" iconProps={{ iconName: 'Upload' }} onClick={() => onUploadFile()} allowDisabledFocus disabled={selectedFile === null} >
                                        { t('data-lang-btn-upload') }
                                    </ActionButton>
                                }
                                {
                                    !uploadInProgress &&
                                    <ActionButton id="btnUpload" iconProps={{ iconName: 'RemoveFilter' }} onClick={() => onCancelUpload()} allowDisabledFocus disabled={selectedFile === null} >
                                        { t('data-lang-btn-cancel') }
                                    </ActionButton>
                                }
                                {
                                    uploadInProgress &&
                                        <Loading
                                            inputParam_ShowLoading={true}
                                            inputParam_ShowText={false}
                                            inputParam_Width={'25px'}
                                            inputParam_Height={'25px'}
                                            inputParam_Left={""}
                                            inputParam_Style={{marginTop: 0}}
                                            inputParam_ColClassName={"me-2"}
                                            inputParam_MarginLeft={"auto"}
                                            inputParam_SpinnerSize={SpinnerSize.medium} />
                                }
                            </>
                        }
                        <Toggle
                            checked={ showDeactivatedDocuments }
                            className={ "pt-2 float-start" }
                            onChange={ onChangeShowDeactivatedDocuments }
                            role="checkbox"
                            onText={ t('data-lang-lbl-all') }
                            offText={ t('data-lang-lbl-active') }
                            styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                        />
                    </div>
                </Col>
                <Col xl={12} className="h-100" style={{minHeight: "150px"}}>
                    <ShimmeredDetailsList
                        className='list-no-filters'
                        enableShimmer={!inputParam_DocumentLinkList}
                        items={inputParam_DocumentLinkList || []}
                        columns={[
                            {
                                key: "documentCode",
                                name: t('data-lang-lbl-code'),
                                fieldName: "documentCode",
                                maxWidth: 100,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.documentCode}
                                            </div>
                                }
                            },
                            {
                                key: "name",
                                name: t('data-lang-lbl-name'),
                                fieldName: "name",
                                maxWidth: 200,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.name}
                                            </div>
                                }
                            },
                            {
                                key: "creationFullname",
                                name: t('data-lang-lbl-creationusername'),
                                fieldName: "creationFullname",
                                maxWidth: 100,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.creationFullname}
                                            </div>
                                }
                            },  
                            {  
                                key: 'id',
                                name: t('data-lang-lbl-actions'),
                                fieldName: 'id',
                                //minWidth: "10%",
                                //maxWidth: "10%",
                                onRender:(item, row) => {
                                    return  <>
                                            {
                                                downloadInProgress &&
                                                <Loading
                                                    inputParam_ShowLoading={true}
                                                    inputParam_ShowText={false}
                                                    inputParam_Width={'25px'}
                                                    inputParam_Height={'25px'}
                                                    inputParam_Left={""}
                                                    inputParam_Style={{marginTop: 0}}
                                                    inputParam_ColClassName={"me-2"}
                                                    inputParam_MarginLeft={"auto"}
                                                    inputParam_SpinnerSize={SpinnerSize.medium} />
                                            }
                                            {
                                                !downloadInProgress &&
                                                <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                        <OverflowSet
                                                            className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                            role="menubar"
                                                            items={[
                                                                {
                                                                    key: 'download',
                                                                    icon: 'CloudDownload',
                                                                    name: t('data-lang-btn-download'),
                                                                    title: t('data-lang-btn-download'),
                                                                    onClick: () => onDownloadDocumentsByIds([item.id], item.name),
                                                                },
                                                                {
                                                                    key: 'deactivate',
                                                                    icon: 'PageRemove',
                                                                    name: t('data-lang-btn-deactivate'),
                                                                    title: t('data-lang-btn-deactivate'),
                                                                    onClick: () => onDeactivateDocumentsByIds(item.id),
                                                                },
                                                                {
                                                                    key: 'delete',
                                                                    icon: 'Delete',
                                                                    name: t('data-lang-btn-delete'),
                                                                    title: t('data-lang-btn-delete'),
                                                                    onClick: () => onDeleteDocumentsByIds(item.id),
                                                                },
                                                            ].filter(x => !inputParam_EditMode ? x.key !== "delete" && x.key !== "deactivate" : item.deactivate ? x.key !== "delete" : true )}
                                                            onRenderOverflowButton={__onRenderOverflowButton}
                                                            onRenderItem={__onRenderOverflowItem}
                                                        />
                                                </div>
                                            }
                                            </>
                                    
                                    
                                }
                            } 
                        ]}
                        getKey={(...args) => (args[0] ? args[0].key : args[1])}
                        setKey="multiple"
                        selectionMode={SelectionMode.none}
                        selectionPreservedOnEmptyClick={true}
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        constrainMode={ConstrainMode.unconstrained}
                        isHeaderVisible={true}
                        enterModalSelectionOnTouch={true}
                    />
                </Col>
            </Row>
}


DataserieValueDocumentBox.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_ObjDataserieValueId: PropTypes.number.isRequired,
    inputParam_SetMessageConfig: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,

    inputParam_DocumentLinkList: PropTypes.array.isRequired,
    inputParam_SetDocumentLinkList: PropTypes.func.isRequired,
};

export default DataserieValueDocumentBox;